import { Observable } from 'rxjs';

import { ListResponse } from '@daikin-tic/dxone-com-lib';

import { DeviceSet, DeviceSetCreateParams, DeviceSetQueryParams } from '../models/device-set.model';

export abstract class DeviceSetGateway {
  abstract listDeviceSets(params: DeviceSetQueryParams): Observable<ListResponse<DeviceSet>>;
  abstract createDeviceSet(params: DeviceSetCreateParams): Observable<DeviceSet>;
  abstract deleteDeviceSet(deviceSetId: string): Observable<void>;
}
